/**
 * Environment Validator
 * Validates that the application is running with correct environment configuration
 * Helps prevent production API being used in UAT environment
 */

export const validateEnvironment = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;

  const validation = {
    baseUrl,
    environment: env,
    isValid: true,
    warnings: [],
  };

  // Check if environment variables are set
  if (!baseUrl) {
    validation.isValid = false;
    validation.warnings.push('REACT_APP_BASE_URL is not set');
  }

  if (!env) {
    validation.warnings.push('REACT_APP_ENV is not set');
  }

  // Validate that UAT environment doesn't use production URL
  if (env === 'uat' && baseUrl?.includes('api.njumu.pos.sababisha.com')) {
    validation.isValid = false;
    validation.warnings.push('⚠️ UAT environment is using PRODUCTION API URL!');
  }

  // Validate that production environment doesn't use UAT URL
  if (env === 'production' && baseUrl?.includes('uat.api.pos.sababisha.com')) {
    validation.isValid = false;
    validation.warnings.push('⚠️ PRODUCTION environment is using UAT API URL!');
  }

  return validation;
};

export const getEnvironmentInfo = () => {
  return {
    baseUrl: process.env.REACT_APP_BASE_URL,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'unknown',
    nodeEnv: process.env.NODE_ENV,
  };
};

export const isProduction = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  return env === 'production';
};

export const isUAT = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
  return env === 'uat';
};
